import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * Menu scroll component.
 * @author Dayne Coulson-Hoffacker
 */
export default class MenuScroll {
  /**
   * Constructs a new Menu scroll instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   * @param {Hurdler} options.hurdler - Hurdler instance.
   */
  constructor (options) {
    this.element = options.element
    this.menusWrapper = this.element.querySelector('.scroll-column')
    this.menus = this.menusWrapper.queryAll('.menu')
    this.menuImages = this.element.queryAll('[data-component="menu-images"] li')

    const self = this

    self.menus.forEach(menu => {
      var index = self.menus.indexOf(menu)
      var waypoint = new Waypoint({
        element: menu,
        handler: function(direction) {
          if (direction == 'up') {
            self.reset(menu, index)
          } else {
            self.activate(menu, index)
          }
        },
        context: self.menusWrapper
      })
    })
  }

  reset (menu, index) {
    this.menuImages[index + 1].classList.remove('visible')
  }

  activate (menu, index) {
    this.menuImages[index + 1].classList.add('visible')
  }

}



// WEBPACK FOOTER //
// ./components/page-menus/index.js